import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useProjectStore } from '@/stores/project'

export const projectPartRoleGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): Promise<void> => {
  const projectStore = useProjectStore()
  const meta = projectStore.getMeta

  if (!meta || !meta.roles?.length) {
    return next({ name: 'summary-project-view' })
  }
  next()
}
